import { t } from "i18next";

export enum TABLE_ITEM_LAYOUT_TYPE {
  CHAT_HISTORY = 1,
  FAQ = 2,
  TERMS_CONDITIONS = 3,
  PRIVACY_POLICY = 4,
  SUGGESTED_QUESTION = 5,
  PAYMENT_METHODS = 6,
}

export enum ORGANIZATION_TYPE {
  SUBSCRIPTION = "subscription",
  NON_SUBSCRIPTION = "non-subscription",
}

export enum ORG_TYPE {
  SUBSCRIPTION = 1,
  NON_SUBSCRIPTION = 2,
}

export enum CRUD_TYPE_ENUM {
  DEFAULT = 0,
  ADD = 1,
  UPDATE = 2,
}

export enum SUBSCRIPTION_TYPE {
  MONTHLY = 1,
  YEARLY = 2,
}

export enum SUBSCRIPTIONS_TYPE {
  MONTHLY = "Monthly",
  YEARLY = "Yearly",
}

export enum APP_THEME {
  DARK = "dark",
  Light = "light",
  SYSTEM = "system",
}

export enum MENU_TYPE {
  PROFILE = 1,
  LOGOUT = 2,
  THEME = 3,
}

export const REQUIREMENTS = [
  "common:password.length",
  "common:password.combination",
  "common:password.upperCase",
  "common:password.lowerCase",
  "common:password.numbers",
  "common:password.specialCharacters",
];

export const SELECTED_PROFILE_TYPES = {
  PROFILE: "profile",
  PASSWORD: "password",
};

export enum PRIVACY_CONTENT_TYPE {
  TABLE = 1,
}

export const TOAST_VARIANT = {
  ERROR: "error",
  SUCCESS: "success",
  COPY_SUCCESS: "copy_success",
  INFO: "warning",
  WARNING: "warning",
};

export const TOAST_VARIANT_COLORS = {
  [TOAST_VARIANT.ERROR]: {
    borderColor: "#F6C23A",
    textColor: "#18191B",
    backgroundColor: "rgba(246, 194, 58, 0.2)",
  },
  [TOAST_VARIANT.SUCCESS]: {
    borderColor: "#40DC91",
    textColor: "#18191B",
    backgroundColor: "#EEFFF7",
  },
  [TOAST_VARIANT.COPY_SUCCESS]: {
    textColor: "#FFFFFF",
    backgroundColor: "#2F3438",
  },
  [TOAST_VARIANT.INFO]: {
    borderColor: "#50B7F0",
    textColor: "#18191B",
    backgroundColor: "#EEF9FF",
  },
  [TOAST_VARIANT.WARNING]: {
    borderColor: "#F6C23A",
    textColor: "#18191B",
    backgroundColor: "#FFFAEC",
  },
};

export const LOADER_STYLES = {
  size: "xl",
  color: "blue",
  thickness: "4px",
};

export const USER_TYPE = {
  SUBSCRIBER: "subscriber",
  NON_SUBSCRIBER: "non-subscriber",
};
export const JOURNALIST_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

export const PAGINATION_DEFAULTS = {
  PAGESIZE: 10,
  THREAD_PAGE_SIZE: 10,
  DOCUMENT_LIST: 20,
};

export const enum TABS_VARIANT {
  DEFAULT = "default",
  CTA = "cta",
}
export const RECORDS_PER_PAGE = 10;
export const RECORDS_PER_PAGE_COURSES = 9;
export const JOURNALIST_COURSE_STATUS = "enrolled";
export const DOCUMENTS_FILTER = "Recents";

export const enum RESPONSE_STATUS {
  SEARCH = "search",
  FILE = "file",
  WEBPAGE = "webpage",
  YOUTUBE = "youtube",
  DEEP_SEARCH = "deepsearch",
}

export const presentationStepsData = () => [
  {
    title: t("common:user_presentation.step1Title"),
    description: t("common:user_presentation.step1Desc"),
  },
  {
    title: t("common:user_presentation.step2Title"),
    description: t("common:user_presentation.step2Desc"),
  },
  {
    title: t("common:user_presentation.step3Title"),
    description: t("common:user_presentation.step3Desc"),
  },
  {
    title: t("common:user_presentation.step4Title"),
    description: t("common:user_presentation.step4Desc"),
  },
];

export const selectOptions = [
  {
    label: "Journalism Ethics",
    value: "journalism_ethics",
    children: [
      { label: "Media Accountability", value: "media_accountability" },
      { label: "Conflict of Interest", value: "conflict_of_interest" },
      { label: "Bias & Objectivity", value: "bias_objectivity" },
      {
        label: "Fact-Checking & Verification",
        value: "fact_checking_verification",
      },
      { label: "Sensitive Coverage", value: "sensitive_coverage" },
    ],
  },
  { label: "Digital & Cyber Safety", value: "digital_cyber_safety" },
  { label: "Reporting Techniques", value: "reporting_techniques" },
  {
    label: "Legal & Regulatory Awareness",
    value: "legal_regulatory_awareness",
  },
  {
    label: "Multimedia & Modern News Formats",
    value: "multimedia_modern_news_formats",
  },
  { label: "Professional Development", value: "professional_development" },
];

export const DELETE = "Delete";
export const EDIT = "Edit";
export const VISIBILITY = "visibility";
export const PIN = "pin";

export const MAX_FILE_SIZE_MB = 500;
export const ACCEPTED_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/msword", // .doc (older Word format)
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls (older Excel format)
];

export const RECIPIENT_TYPES = {
  SUBSCRIBER: 1,
  JOURNALIST: 2,
  NON_AUTH: 4,
  // Legacy: BOTH=3 is Subscriber|Journalist (1|2), kept for reading old DB values
  BOTH: 3,
};
export const NewsPaperType = {
  Daily: "1",
  Weekly: "2",
  Other: "3",
};

export const stepperSteps = () => [
  { label: t("courseCreate.basicCourseInfo"), currentStep: 1 },
  { label: t("courseCreate.addChaptersAndVideos"), currentStep: 2 },
  { label: t("courseCreate.courseSettings"), currentStep: 3 },
];

export const requirementOptions = () => [
  { value: "1", label: t("courseCreate.optional") },
  { value: "2", label: t("courseCreate.required") },
];

export const userTypeOptions = () => [
  { value: 1, label: t("courseCreate.subscriber") },
  { value: 2, label: t("courseCreate.nonSubscriber") },
];

export enum EnrollmentOptionType {
  none = "none",
  duration = "duration",
  period = "period",
}

export enum Present {
  none = 0,
}

// dynamic data for chapters and videos
export const chaptersWithVideos: ChapterWithVideos[] = [
  {
    id: "1",
    name: "Chapter 1",
    videos: [],
  },
  {
    id: "2",
    name: "Chapter 2",
    videos: [
      { id: "2_1", name: "Video 1" },
      { id: "2_2", name: "Video 2" },
    ],
  },
  {
    id: "3",
    name: "Chapter 3",
    videos: [
      { id: "3_1", name: "Video 1" },
      { id: "3_2", name: "Video 2" },
      { id: "3_3", name: "Video 3" },
      { id: "3_4", name: "Video 4" },
    ],
  },
  {
    id: "4",
    name: "Chapter 4",
    videos: [
      { id: "4_1", name: "Video 1" },
      { id: "4_2", name: "Video 2" },
    ],
  },
];

export const courseAccessOptions: CourseAccessOption[] = [
  {
    name: "displayOnHome",
    labelKey: "setPreferance.displayOnHome",
  },
  {
    name: "freeAccessEnabled",
    labelKey: "setPreferance.publicAccess",
  },
];

export const enrollmentOptions: EnrollmentOption[] = [
  {
    value: EnrollmentOptionType.none,
    labelKey: "setPreferance.noEnrollmentPeriod",
  },
  {
    value: EnrollmentOptionType.duration,
    labelKey: "setPreferance.enrollmentDuration",
  },
  {
    value: EnrollmentOptionType.period,
    labelKey: "setPreferance.enrollmentPeriod",
  },
];

export const TAB_TYPES = {
  COURSES: 0,
  NOTICES: 1,
};

export const PROFILE_CHANGE_EVENT_TYPES = {
  EMAIL: "email",
  PROFILE_PICTURE: "profile_picture",
  ORGANIZATION: "organization",
  PHONE: "phone",
  NAME: "name",
  COMPANY_NAME: "company_name",
  SUBSCRIBER_ID: "subscriber_id",
  PASSWORD: "password",
  LANGUAGE: "language",
};

export const COURSE_STATUS = {
  DRAFT: 1,
  PUBLISHED: 2,
};

export const getCourseStatus = () => ({
  1: t("course.draft"),
  2: t("course.published"),
});

export const COURSE_REQUIREMENT = {
  ESSENTIAL: 2,
  OPTIONAL: 1,
};

export enum REQUIREMENT_TYPE {
  REQUIRED = 2,
  OPTIONAL = 1,
}

export enum SUBSCRIBER_TYPE {
  SUBSCRIBER = 3,
  NON_SUBSCRIBER = 4,
}

export enum COURSE_ENROLLMENT_STATUS {
  ENROLLED = "enrolled",
  WATCHLATER = "watchlater",
  COMPLETED = "completed",
  DROPPED = "dropped",
}

export enum PUBLISH_VISIBILITY {
  ACTIVE = "Active",
  UNASSIGNED = "Unassigned",
}

export enum TRANSCODING_STATUS {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "cancelled",
}
